import { lazy } from "react";

const routes = [
  {
    path: "/subcategory-location-mapping",
    element: lazy(() =>
      import("../pages/Category/SubCategoryLocationMapping")
    ),
  },
  {
    path: "/subcategory-location-mapping/add",
    element: lazy(() =>
      import("../pages/Category/SubCategoryLocationMappingForm")
    ),
  },
  {
    path: "/subcategory-location-mapping/add/:id",
    element: lazy(() =>
      import("../pages/Category/SubCategoryLocationMappingForm")
    ),
  },
];

export default routes;
